export const eventDuration = [15, 30, 45, 60, 120];
